import React, { useEffect } from 'react';
import {
  Box,
  FlexControlledForm,
  useDebounceState,
} from '@common-fe/common-fe';

import { InvestmentProfilePayload,useStore } from '../stores/useInvestmentProfile.store';

import { useRiskToleranceTypeFields } from './hooks';

interface Props {
  onDirty?: (isDirty: boolean) => void;
}

const RiskToleranceType: React.FC<Props> = ({ onDirty }) => {
  const fields = useRiskToleranceTypeFields();
  const handleSetState = useStore((state) => state.setState);
  const showErrors = useStore((state) => state.showErrors);

  const { setValues, values } = useDebounceState<Partial<InvestmentProfilePayload>>();

  useEffect(() => {
    if (values) {
      handleSetState(values);
    }
  }, [handleSetState, values]);
  return (
    <Box background="canvas" round="container1Round" margin={{ bottom: 'l' }} style={{ position: 'relative' }} data-testid="RiskToleranceType-wrapper">
      <FlexControlledForm
        fields={fields}
        shouldControlValues
        testId="risk_tolerance_type_form"
        showError={showErrors}
        editMode
        onChangeValues={setValues}
        onDirty={onDirty}
      />
    </Box>
  );
};
export default RiskToleranceType;
